import React, { useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
export function PurchasePopup() {
  const [show, setShow] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: ''
  });
  const names = ['Martín', 'Luciana', 'Diego', 'Gabriela', 'Carlos', 'Ana', 'Roberto', 'Javier', 'María', 'Fernando', 'Sofía', 'Pablo', 'Valentina', 'Matías', 'Camila'];
  const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Tucumán', 'Neuquén', 'Bahía Blanca'];
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentPurchase({
        name: randomName,
        city: randomCity
      });
      setShow(true);
      setTimeout(() => {
        setShow(false);
      }, 5000);
    };
    const initialDelay = setTimeout(showPopup, 3000);
    const interval = setInterval(showPopup, 15000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, []);
  if (!show) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-slide-in" data-id="element-115">
      <div className="bg-white rounded-lg shadow-2xl p-4 max-w-sm border-2 border-green-500" data-id="element-116">
        <div className="flex items-start justify-between mb-2" data-id="element-117">
          <div className="flex items-center gap-2" data-id="element-118">
            <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse" data-id="element-119"></div>
            <p className="font-semibold text-gray-900" data-id="element-120">Compra reciente</p>
          </div>
          <button onClick={() => setShow(false)} className="text-gray-400 hover:text-gray-600" data-id="element-121">
            <XIcon className="w-4 h-4" data-id="element-122" />
          </button>
        </div>
        <p className="text-sm text-gray-700" data-id="element-123">
          <span className="font-semibold" data-id="element-124">{currentPurchase.name}</span> de{' '}
          <span className="font-semibold" data-id="element-125">{currentPurchase.city}</span> acaba de
          comprar este libro digital
        </p>
        <p className="text-xs text-gray-500 mt-1" data-id="element-126">Hace unos minutos</p>
      </div>
    </div>;
}